angular.module('zc.master.projects')

.controller('MasterProjectsPoliciesCtrl', ($scope, $state, $stateParams, $translate, Page, currentProject, campaignPolicySets) ->
  Page.setBodyClass ''
  $translate('masterProjects.masterProjectsPolicies.deliveryConfirmationScreen').then (translation) ->
    Page.setTitle translation

  $scope.headers = []
  $scope.currentProject = currentProject
  $scope.campaignPolicySets = campaignPolicySets

  $scope.currentPolicySetId = parseInt($stateParams.campaignPolicySetId)
  $scope.currentPolicySetId = undefined if isNaN($scope.currentPolicySetId)

  $scope.goto = () ->
    return if angular.isUndefined($scope.currentPolicySetId)
    $state.go 'admin.master.projects.policies.show', {
      projectId: $scope.currentProject.id
      campaignPolicySetId: $scope.currentPolicySetId
    }

  $scope.updatePolicies = () ->
    $scope.currentPolicySet = _.chain($scope.campaignPolicySets)
                                .filter((s) -> s.id == $scope.currentPolicySetId)
                                .head()
                                .value()

    $scope.headers = MasterCampaignPolicy.getRelevantHeaders($scope.currentCampaignPolicySet.campaign_policies)

  if angular.isDefined($scope.currentPolicySetId)
    $scope.currentPolicySet = _.chain($scope.campaignPolicySets)
                                .filter((s) -> s.id == $scope.currentPolicySetId)
                                .head()
                                .value()
    if $scope.currentPolicySet
      $scope.updatePolicies()
  else
    $scope.currentPolicySet = undefined
)



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.projects/master_projects_policies.controller.js.coffee